export const panelSplitterDragDataSymbol: unique symbol = Symbol('panel-splitter-drag-data');
